import React from 'react';
import PropTypes from 'prop-types';
import blocks from '../../blocks';
import elements from '../../elements';
import './ChatSessionsComponent.scss';

class ChatSessionsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortedChatFeed: [],
    };
  }

  componentDidMount() {
    this.processChatList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chatList !== this.props.chatList) {
      this.processChatList();
    }
  }

  processChatList = () => {
    const { active, chatList, setActiveChatSession } = this.props;

    if (!chatList?.loading && Array.isArray(chatList?.data)) {
      const filtered = this.sortChatSessionWithNullValues(
        chatList.data.filter(item => !item.multiuser_chat),
        false
      );

      const matched = filtered.find(chat => chat.id === active);
      const defaultChat = matched || filtered[0];

      if (!active || !matched) {
        setActiveChatSession(defaultChat?.id);
      }

      this.setState({ sortedChatFeed: filtered });
    }
  };

  handleChatSessionClicked = (chatId) => {
    const { setActiveChatSession, ResetNotifyNewChatMessage } = this.props;
    setActiveChatSession(chatId);
    ResetNotifyNewChatMessage(chatId);
  };

  sortChatSessionWithNullValues = (arr, ascending = true) => {
    const multiplier = ascending ? 1 : -1;
    return [...arr].sort((a, b) => {
      if (!a.updated_at && !b.updated_at) return 0;
      if (!a.updated_at) return 1;
      if (!b.updated_at) return -1;
      return new Date(a.updated_at) > new Date(b.updated_at) ? 1 * multiplier : -1 * multiplier;
    });
  };

  handleDeleteSession = (chatId) => {
    const { archiveChatSession, } = this.props;
    console.log('Delete chat:', chatId);
    archiveChatSession(chatId);
    // Implement delete logic
  };

  handleMuteSession = (chatId) => {
    console.log('Mute chat:', chatId);
    // Implement mute logic
  };

  render() {
    const { chatList, active, locations, locationId } = this.props;
    const { sortedChatFeed } = this.state;

    return (
      <elements.ColumnWrap maxWidth="360px">
        <elements.ScrollWrap>
          {chatList.loading ? (
            <elements.Loading />
          ) : (
            sortedChatFeed.map((chat) => (
              <blocks.ChatSession
                key={chat.id}
                active={chat.id === active}
                chat={chat}
                handleClick={this.handleChatSessionClicked}
                locations={locations}
                locationId={locationId}
                onDelete={this.handleDeleteSession}
                onMute={this.handleMuteSession}
              />
            ))
          )}
        </elements.ScrollWrap>
      </elements.ColumnWrap>
    );
  }
}

ChatSessionsComponent.propTypes = {
  active: PropTypes.number.isRequired,
  chatList: PropTypes.object.isRequired,
  setActiveChatSession: PropTypes.func.isRequired,
  ResetNotifyNewChatMessage: PropTypes.func.isRequired,
  locations: PropTypes.array,
  locationId: PropTypes.string,
};

export default ChatSessionsComponent;
